<template>
  <section class="app-documents">
    <v-container>
      <services-list :data="services"></services-list>
    </v-container>
  </section>
</template>

<script>
import { services } from "@/models/service";
import ServicesList from "@/components/ServicesList";

export default {
  components: {
    ServicesList
  },
  metaInfo: {
    title: "Documentos - Central de Serviços"
  },
  data: () => {
    return {
      services: [services[3]]
    };
  }
};
</script>

<style>
</style>